import { useCallback } from 'react';
import { useLazyQuery } from 'react-apollo';
import gql from 'graphql-tag';

import { useContentTreeSelectionActions } from './store';

const ContentMetadataQuery = gql`
	query useSelectionCountContentMetadataQuery($contentIds: [ID!]!) {
		pageContent: content(ids: $contentIds, type: "page") {
			nodes {
				id
				visibleDescendantsCount
			}
		}
		whiteboardContent: content(ids: $contentIds, type: "whiteboard") {
			nodes {
				id
				visibleDescendantsCount
			}
		}
		databaseContent: content(ids: $contentIds, type: "database") {
			nodes {
				id
				visibleDescendantsCount
			}
		}
		embedContent: content(ids: $contentIds, type: "embed") {
			nodes {
				id
				visibleDescendantsCount
			}
		}
		folderContent: content(ids: $contentIds, type: "folder") {
			nodes {
				id
				visibleDescendantsCount
			}
		}
	}
`;

export const useSelectionCount = () => {
	const { updateCount, addLoadingDescendant, removeLoadingDescendant } =
		useContentTreeSelectionActions();

	const [fetchMetadata] = useLazyQuery(ContentMetadataQuery, {
		fetchPolicy: 'network-only',
		onCompleted: (data) => {
			const nodes = [
				...(data?.pageContent?.nodes ?? []),
				...(data?.whiteboardContent?.nodes ?? []),
				...(data?.databaseContent?.nodes ?? []),
				...(data?.embedContent?.nodes ?? []),
				...(data?.folderContent?.nodes ?? []),
			];
			nodes.forEach((node) => {
				updateCount(node.id, node.visibleDescendantsCount);
				removeLoadingDescendant(node.id);
			});
		},
		onError: () => {},
	});

	const selectDescendantCount = useCallback(
		(parentsForCount: Set<string>) => {
			const parents = Array.from(parentsForCount);
			parents.forEach((parentId) => addLoadingDescendant(parentId));
			fetchMetadata({ variables: { contentIds: parents } });
		},
		[addLoadingDescendant, fetchMetadata],
	);

	return { selectDescendantCount };
};
